<template>
  <v-app fixed>
    <v-progress-linear
      v-if="loading"
      color="primary"
      height="5"
      :indeterminate="true"
      style="margin: 0;"
    />

    <MainNavigationBar v-if="navBar" style="z-index: 1000" />

    <v-layout column class="sg-main-content">
      <slot />

      <!-- <LandingFooter v-if="!hideFooter" class="flex-none" /> -->
    </v-layout>
  </v-app>
</template>

<script>
import MainNavigationBar from "@/components/MainNavigationBar";
// import LandingFooter from "./LandingFooter";

export default {
  components: {
    MainNavigationBar
    // LandingFooter
  },

  props: {
    navBar: {
      type: Boolean,
      default: true
    },

    hideFooter: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    loading() {
      return this.$store.state.app.loading;
    }
  }
};
</script>

<style lang="css" scoped>
.sg-main-content {
  flex: 1;
  min-height: 0;
  background-color: var(--secondary-dark);
}
</style>
